// Module
var code = "<abx-detail-header abx-building=\"vm.building\" abx-heading=\"vm.floor.name\" abx-model=\"vm.floor\" abx-model-type=\"floor\" abx-subtitle=\"vm.subtitle\" abx-tabs=\"vm.tabs\"> </abx-detail-header> <div ui-view flex layout=\"column\" class=\"scroll-y\"></div> ";
// Exports
module.exports = code;